import { Auth } from 'services'

const auth = new Auth()

const Authenticated = (props: any) => {
    return auth.isAuthenticated() && props.children
}

export default Authenticated



// WEBPACK FOOTER //
// ./src/components/Authenticated/index.tsx